// Shared org unit logo files data
// These files are stored in the File Library and referenced by org units

export interface OrgUnitLogoFile {
  id: string
  name: string
  type: string
  size: number
  uploadDate: string
  lastModified: string
  uploadedBy: string
  status: string
  department: string
  tags: string[]
  storageLocation: string
  accessLevel: string
  thumbnailUrl: string
  parentFiles: any[]
  childFiles: any[]
  linkedEntities: Array<{
    id: string
    type: string
    name: string
  }>
}

export const orgUnitLogoFiles: OrgUnitLogoFile[] = [
  {
    id: 'file-001',
    name: 'Global_Technologies_Logo.png',
    type: 'png',
    size: 45000,
    uploadDate: '2023-01-01T00:00:00Z',
    lastModified: '2023-01-01T00:00:00Z',
    uploadedBy: 'System',
    status: 'Active',
    department: 'Corporate',
    tags: ['logo', 'branding', 'organisation'],
    storageLocation: 's3://company-docs/org-units/logos',
    accessLevel: 'All Employees',
    thumbnailUrl:
      'https://ui-avatars.com/api/?name=Global+Technologies&background=4F46E5&color=fff&size=200&bold=true&length=2',
    parentFiles: [],
    childFiles: [],
    linkedEntities: [
      {
        id: 'org-001',
        type: 'Organisation Unit',
        name: 'Global Technologies Inc.',
      },
    ],
  },
  {
    id: 'file-002',
    name: 'European_Operations_Logo.png',
    type: 'png',
    size: 38000,
    uploadDate: '2023-02-01T00:00:00Z',
    lastModified: '2023-02-01T00:00:00Z',
    uploadedBy: 'System',
    status: 'Active',
    department: 'Corporate',
    tags: ['logo', 'branding', 'organisation'],
    storageLocation: 's3://company-docs/org-units/logos',
    accessLevel: 'All Employees',
    thumbnailUrl:
      'https://ui-avatars.com/api/?name=European+Operations&background=10B981&color=fff&size=200&bold=true&length=2',
    parentFiles: [],
    childFiles: [],
    linkedEntities: [
      {
        id: 'org-004',
        type: 'Organisation Unit',
        name: 'European Operations Ltd',
      },
    ],
  },
  {
    id: 'file-003',
    name: 'APAC_Technologies_Logo.png',
    type: 'png',
    size: 42000,
    uploadDate: '2023-03-01T00:00:00Z',
    lastModified: '2023-03-01T00:00:00Z',
    uploadedBy: 'System',
    status: 'Active',
    department: 'Corporate',
    tags: ['logo', 'branding', 'organisation'],
    storageLocation: 's3://company-docs/org-units/logos',
    accessLevel: 'All Employees',
    thumbnailUrl:
      'https://ui-avatars.com/api/?name=Asia+Pacific+Technologies&background=F59E0B&color=fff&size=200&bold=true&length=2',
    parentFiles: [],
    childFiles: [],
    linkedEntities: [
      {
        id: 'org-006',
        type: 'Organisation Unit',
        name: 'Asia Pacific Technologies Pty Ltd',
      },
    ],
  },
]
